import "./SiteLayout.html";
import "./SiteLayout.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteLayoutComponentController from "./SiteLayoutComponentController";

export class SiteLayoutComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = SiteLayoutComponentController;
        this.templateUrl = "/App/Components/Site/SiteLayout/SiteLayout.html";
    }
}

module("mmManagePortal").component("mmSiteLayout", new SiteLayoutComponent());
